module.exports = {"buttons":{"signup":{"url":"/#membership","label":"Sign Up"},"signin":{"url":"https://app.rescuepaws.org.uk","label":"Sign In"}}}